// extracted by mini-css-extract-plugin
export default {"container":"TableData_container__V7gFb","actions_table":"TableData_actions_table__5sNqZ"};